import { render, staticRenderFns } from "./DDIs.vue?vue&type=template&id=7124f7c0&scoped=true"
import script from "./DDIs.vue?vue&type=script&lang=js"
export * from "./DDIs.vue?vue&type=script&lang=js"
import style0 from "./DDIs.vue?vue&type=style&index=0&id=7124f7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7124f7c0",
  null
  
)

export default component.exports